export const OPEN_R2C_JOBSHEET_REFERENCE_SIDEPANEL =
  'openR2CJobsheetReferenceSidePanel'
export const CLOSE_R2C_JOBSHEET_REFERENCE_SIDEPANEL =
  'closeR2CJobsheetReferenceSidePanel'
export const OPEN_R2C_TASK_SIDEPANEL = 'openR2CTaskSidePanel'
export const CLOSE_R2C_TASK_SIDEPANEL = 'closeR2CTaskSidePanel'
export const OPEN_R2C_ADD_TO_BASKET_PANEL = 'openR2CAddToBasketPanel'
